
import authAxios from "@/utilities/authAxios.js";
import decodeJWT from "@/utilities/decodeJWT.js";
import handleError from "@/utilities/handleError.js";

const UserService = {

	getUserInfo() {
    return authAxios.get(import.meta.env.VITE_WHQ_USER_SERVICE_URL + "/current").then(response => {
      if (response.data.principalFound) {
        return response.data;
      } else {
        return UserService.registerNewUser().then(data => {
          return authAxios.get(import.meta.env.VITE_WHQ_USER_SERVICE_URL + "/current").then(response => {
            if (response.data.principalFound) {
              return response.data;
            } else {
              handleError({ response: { status: 200, data: { message: "WHQ principal user information not found after registration." }, request: { responseURL: import.meta.env.VITE_WHQ_USER_SERVICE_URL + "/current" } } });
              return { httpError: true };
            }
          }).catch(error => { handleError(error); return { httpError: true }; });
        }).catch(error => { handleError(error); return { httpError: true }; });
      }
    }).catch(error => { handleError(error); return { httpError: true }; });
  },

  registerNewUser() {
    let idToken = decodeJWT(JSON.parse(localStorage.getItem("authTokens")).id_token);
    return authAxios.post(import.meta.env.VITE_WHQ_USER_SERVICE_URL + "/register", {
      subject: idToken["sub"],
      email_verified: idToken["email_verified"],
      given_name: idToken["given_name"],
      family_name: idToken["family_name"],
      email: idToken["email"],
      username: idToken["cognito:username"],
      image_url: idToken["picture"] ?? null,
      issuer: idToken["iss"],
      client_id: idToken["aud"]
    }).then(response => {
      let responseErrors = response.data.errors;
      if (responseErrors) {
        let errors = [];
        if (responseErrors.fieldErrors) responseErrors.fieldErrors.forEach((fieldError) => errors.push(fieldError.defaultMessage));
        if (responseErrors.globalErrors) responseErrors.globalErrors.forEach((globalError) => errors.push(globalError.defaultMessage));
        handleError({ response: { status: 200, data: { message: errors.join(" ") }, request: { responseURL: import.meta.env.VITE_WHQ_USER_SERVICE_URL + "/register" } } });
        return { httpError: true };
      }
    }).catch(error => { handleError(error); return { httpError: true }; });
  },

  logSecurityEvent(event) {
    return authAxios.post(import.meta.env.VITE_WHQ_USER_SERVICE_URL + "/security/event", event)
      .then(response => response.data).catch(error => { /*does not call handleError(error);*/ return { httpError: true }; });
  }

}

export default UserService;